import { DesignLanguage } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import React, { ReactElement } from "react";
import { useTheme } from "styled-components";

function Circle(): ReactElement {
    const theme = useTheme();
    const isToing = theme.designLanguage === DesignLanguage.TOING;
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
                cx="6"
                cy="6"
                r="4.5"
                fill="white"
                stroke={isToing ? theme.colors[theme.colorMode].primary : theme.colors[theme.colorMode].rain}
                strokeWidth="3"
            />
        </svg>
    );
}

export default Circle;
